// import Cookies from 'cookies-js';
import { Message } from 'element-ui';
import { getSearchedPO } from '../../services/purchase-orders';
import * as types from '../mutation-types';


const state = {
  poItems: [],
  poItemsSelected: [],
  searchbarQuery: '',
  searchFilterQuery: '',
  searchFilterSelected: [],
  endDatesRange: [],
  pagination: {},
  totalPOs: '',
  paginationQuery: 'page=1&perPage=25',
  orderBy: '&o=-created',
  isPosLoading: true,
};

const getters = {
  getSearchQueryString: (state) => {
    let filtersQuery = '';
    // verify searchQuery
    if (state.searchbarQuery !== '') {
      filtersQuery += `${state.searchbarQuery}`;
    }
    // verify filters
    for (let i = 0; i < state.searchFilterSelected.length; i += 1) {
      if (filtersQuery !== '') {
        filtersQuery += '&';
      }
      filtersQuery += `status=${state.searchFilterSelected[i]}`;
    }
    // verify dueDate
    if (state.endDatesRange !== null && state.endDatesRange.length > 0) {
      if (filtersQuery !== '') {
        filtersQuery += '&';
      }
      filtersQuery += `endDate_0=${state.endDatesRange[0]}`;
      filtersQuery += `&endDate_1=${state.endDatesRange[1]}`;
    }
    if (filtersQuery !== '') {
      filtersQuery += '&';
    }
    filtersQuery += `${state.paginationQuery}${state.orderBy}`;
    filtersQuery = `?${filtersQuery}`;
    return filtersQuery;
  },
  getFilterQuery: state => state.searchFilterQuery,
  getFilterSelected: state => state.searchFilterSelected,
  getSearchQuery: state => state.searchbarQuery,
  getPoItems: state => state.poItems,
  getPoItemsSelected: state => state.poItemsSelected,
  getPagination: state => state.pagination,
  getPOTotal: state => state.totalPOs,
  getOrderBy: state => state.orderBy,
  getLoading: state => state.isPosLoading,
  getPOEndDatesRange: state => state.endDatesRange,
};

const mutations = {
  [types.SET_PO_LOADING](state, isLoading) {
    state.isPosLoading = isLoading;
  },
  [types.ADD_TO_PO_ITEMS](state, purchaseOrder) {
    state.poItems = purchaseOrder;
    state.isPosLoading = false;
  },
  [types.PUSH_TO_PO_ITEMS](state, purchaseOrder) {
    state.poItems.unshift(purchaseOrder);
    state.poItems.pop();
  },
  [types.ADD_SEARCH_FILTER_QUERY](state, searchFilterPOQuery) {
    state.searchFilterQuery = searchFilterPOQuery.query;
    state.searchFilterSelected = searchFilterPOQuery.filterSelected;
  },
  [types.SET_PO_PAGINATION](state, pagination) {
    state.pagination.perPage = parseInt(pagination.perPage); //eslint-disable-line
    state.pagination.page = pagination.page;
    state.pagination.total = pagination.total;
    state.paginationQuery = `page=${pagination.page}&perPage=${pagination.perPage}`;
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy;
  },
  [types.ADD_SEARCHBAR_QUERY](state, searchbarQuery) {
    if (searchbarQuery === '') {
      state.searchbarQuery = searchbarQuery;
    } else {
      state.searchbarQuery = `q=${searchbarQuery}`;
    }
  },
  [types.ADD_PO_SELECTED](state, itemSelected) {
    state.poItemsSelected = itemSelected;
  },
  [types.SET_PO_END_DATE_RANGE](state, endDatesRange) {
    state.endDatesRange = endDatesRange;
  },
};

const actions = {
  getSearchedPOData({ commit, getters }, changePage) {
    commit(types.SET_PO_LOADING, true);
    let searchedUrl;
    let searchedQuery;
    if (!changePage) {
      const paginationObj = {};
      if (typeof getters.getPagination.perPage === 'undefined') {
        paginationObj.perPage = '25';
      } else {
        paginationObj.perPage = getters.getPagination.perPage;
      }
      paginationObj.page = 1;
      commit(types.SET_PO_PAGINATION, paginationObj);
    }
    const queryFilter = getters.getSearchQueryString;
    getSearchedPO(queryFilter).then((response) => {
      searchedUrl = response.config.url;
      return response.data;
    }).then((data) => {
      searchedQuery = searchedUrl.substring(searchedUrl.lastIndexOf('?q=') + 1, searchedUrl.indexOf('&'));
      if (getters.getSearchQuery.indexOf('q=') === -1) {
        commit(types.ADD_TO_PO_ITEMS, data.results);
        commit(types.SET_PO_PAGINATION, data.pagination);
        commit(types.SET_PO_LOADING, false);
      } else if (getters.getSearchQuery === searchedQuery) {
        commit(types.ADD_TO_PO_ITEMS, data.results);
        commit(types.SET_PO_PAGINATION, data.pagination);
        commit(types.SET_PO_LOADING, false);
      }
    }).catch((error) => {
      commit(types.SET_PO_LOADING, false);
      if (error.response.data.message) {
        Message.error(error.response.data.message);
      } else {
        Message.error('Something went wrong! Try again.');
      }
    });
  },
  pushPOItems({ commit }, poObj) {
    return commit(types.PUSH_TO_PO_ITEMS, poObj);
  },
  setPOItems({ commit }, arr) {
    return commit(types.ADD_TO_PO_ITEMS, arr);
  },
  setFilterSearchPO({ commit }, q) {
    return commit(types.ADD_SEARCH_FILTER_QUERY, q);
  },
  setSearchQuery({ commit }, q) {
    return commit(types.ADD_SEARCHBAR_QUERY, q);
  },
  setPoSelectedEndDatesRange({ commit }, endDatesRange) {
    return commit(types.SET_PO_END_DATE_RANGE, endDatesRange);
  },
  setPOSelected({ commit }, items) {
    return commit(types.ADD_PO_SELECTED, items);
  },
  updatePagination({ commit }, paginationQuery) {
    return commit(types.SET_PO_PAGINATION, paginationQuery);
  },
  updateOrderBy({ commit }, orderByQuery) {
    return commit(types.SET_ORDER_BY, orderByQuery);
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/purchase-orders.js